import styles from "./EnquiryForms.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoAddCircleOutline } from "react-icons/io5";

const data = [
  {
    _id: "1",
    title: "Instagram",
    status: "Live",
    submission: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
  {
    _id: "2",
    title: "Instagram",
    status: "Live",
    submission: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
  {
    _id: "3",
    title: "Instagram",
    status: "Live",
    submission: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
  {
    _id: "4",
    title: "Instagram",
    status: "Live",
    submission: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
];
  



function EnquiryForms() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);


  const handlecreateform = () => {
    dispatch(openModal("createForm"));
  };
  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        title: (
          <div className={styles.titleCell}>
            <RiFileTextLine className={styles.fileIcon} />
            {item.title}
          </div>
        ),
        status: (
          <div className={styles.status}>
            <span className={styles.greenDot}></span>
            Live
          </div>
        ),
        submission: item.submission,
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => console.log(`Selected ${opt} for ${item.title}`)}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Title", accessor: "title" },
    { title: "Status", accessor: "status" },
    { title: "Submission", accessor: "submission" },
    { title: "Action", accessor: "action" },
  ];
  

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}
        <div className={styles.createForm}>
          <IconAndName
            icon={<IoAddCircleOutline />}
            title="Create Form"
            bgColor="Primary_Color"
            onClick={handlecreateform}
          />
        </div>

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search by name"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <Dropdown
              label="All Status"
              options={["Live", "Inactive", "Draft"]}
              bgColor="rgba(240, 240, 240, 1)"
              borderRadius="10px"
            />
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default EnquiryForms;
